import React, { useState } from 'react';
import { newPaymentSchemeOptions } from '../../utils/constant';
import DialogModal from '../../../../components/DialogModal';
import { StyledButton } from '../../styled';
import { CircularProgress } from '@mui/material';
import DropdownSelect from '../../../../components/DropdownSelect';

const AddNewPaymentOptionForm = ({
  open,
  onClose,
  handleAddPaymentScheme
}: {
  open: boolean;
  onClose: () => void;
  handleAddPaymentScheme: ({
    selectedPaymentSchemeName
  }: {
    selectedPaymentSchemeName: string;
  }) => void;
}) => {
  const [selectedPaymentSchemeName, setSelectedPaymentSchemeName] =
    useState<string>('');
  const [isSubmitting, setIsSubmitting] = useState<boolean>(false);

  const paymentSchemeOptions = newPaymentSchemeOptions.map((option) => ({
    label: option.label,
    value: option.label
  }));

  const handleModalClose = () => {
    setSelectedPaymentSchemeName('');
    onClose();
  };

  const handleAddNewPaymentScheme = () => {
    setIsSubmitting(true);
    handleAddPaymentScheme({ selectedPaymentSchemeName });
    setIsSubmitting(false);
    onClose();
  };

  return (
    <DialogModal
      open={open}
      onClose={handleModalClose}
      title='Add Payment Option'
      actions={
        <StyledButton
          onClick={handleAddNewPaymentScheme}
          disabled={isSubmitting || !selectedPaymentSchemeName}
        >
          {isSubmitting ? (
            <CircularProgress size={24} color='inherit' />
          ) : (
            'Add'
          )}
        </StyledButton>
      }
    >
      <DropdownSelect
        label='Option Name'
        placeholder='Select Option Name'
        name='Option Name'
        value={selectedPaymentSchemeName}
        onChange={(e) => setSelectedPaymentSchemeName(e.target.value as string)}
        options={paymentSchemeOptions}
        hasTopLabel
        hintText={selectedPaymentSchemeName ? '' : 'This is required field*'}
      />
    </DialogModal>
  );
};

export default AddNewPaymentOptionForm;
